var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-alert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-alert",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "!",
    transform: "translate(11.093750, 4.375000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.53125,1.125 C2.53125,0.796875 2.42578125,0.52734375 2.21484375,0.31640625 L2.21484375,0.31640625 C2.00390625,0.10546875 1.734375,0 1.40625,0 C1.078125,0 0.80859375,0.10546875 0.59765625,0.31640625 C0.38671875,0.52734375 0.28125,0.796875 0.28125,1.125 L0.28125,10.125 C0.28125,10.453125 0.38671875,10.7226562 0.59765625,10.9335938 C0.80859375,11.1445312 1.078125,11.25 1.40625,11.25 C1.734375,11.25 2.00390625,11.1445312 2.21484375,10.9335938 C2.42578125,10.7226562 2.53125,10.453125 2.53125,10.125 L2.53125,1.125 Z M1.40625,15.75 C1.8046875,15.75 2.1328125,15.609375 2.390625,15.328125 L2.390625,15.328125 C2.671875,15.0703125 2.8125,14.7421875 2.8125,14.34375 C2.8125,13.9453125 2.671875,13.6171875 2.390625,13.359375 C2.1328125,13.078125 1.8046875,12.9375 1.40625,12.9375 C1.0078125,12.9375 0.6796875,13.078125 0.421875,13.359375 C0.140625,13.6171875 0,13.9453125 0,14.34375 C0,14.7421875 0.140625,15.0703125 0.421875,15.328125 C0.6796875,15.609375 1.0078125,15.75 1.40625,15.75 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlarm);
export default __webpack_public_path__ + "static/media/ic-alarm.a08ed28e33b744eda9a32487325aaefd.svg";
export { ForwardRef as ReactComponent };